module.exports = __webpack_public_path__ + "img/exclamation.67ef6b3f.png";